export function firstOfMonth(rawDate) {
	const dateArray = rawDate.split('-')
	return [dateArray[0], dateArray[1], '01'].join('-')
}

export function firstOfYear(rawDate) {
	const dateArray = rawDate.split('-')
	return [dateArray[0], '01', '01'].join('-')
}

export function lastOfYear(rawDate) {
	const dateArray = rawDate.split('-')
	return [dateArray[0], '12', '31'].join('-')
}

export function lastOfMonth(rawDate) {
	const dateArray = rawDate.split('-')
	const date = new Date(dateArray[0], parseInt(dateArray[1], 10), 0)
	return [dateArray[0], dateArray[1], date.getDate()].join('-')
}

export function lastMonth(rawDate) {
	const dateArray = rawDate.split('-')
	const date = new Date(
		dateArray[0],
		parseInt(dateArray[1], 10) - 2,
		parseInt(dateArray[2], 10),
	)
	return [
		date.getFullYear(),
		(date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1),
		(date.getDate() < 10 ? '0' : '') + date.getDate(),
	].join('-')
}

export function lastYear(rawDate) {
	const dateArray = rawDate.split('-')
	const date = new Date(
		dateArray[0] - 1,
		parseInt(dateArray[1], 10) - 1,
		parseInt(dateArray[2], 10),
	)
	return [
		date.getFullYear(),
		dateArray[1],
		(date.getDate() < 10 ? '0' : '') + date.getDate(),
	].join('-')
}

export function diffDays(startDate, endDate) {
	return Math.round(Math.abs(Date.parse(endDate) - Date.parse(startDate)) / 8.64e+7)
}

export function today() {
	const date = new Date()
	return [
		date.getFullYear(),
		(date.getMonth() < 9 ? '0' : '') + (parseInt(date.getMonth(), 10) + 1),
		(date.getDate() < 10 ? '0' : '') + date.getDate(),
	].join('-')
}
